import { siteConfig } from "@/config/site";
import { useLocale } from "@/i18n/locale-context";
import { getLocaleContent } from "@/lib/site-config";
import type { LocaleContent, SharedSiteConfig } from "@/types/site";

export function useSiteContent(): LocaleContent {
  const { locale } = useLocale();
  return getLocaleContent(siteConfig, locale);
}

export function useSiteShared(): SharedSiteConfig {
  return siteConfig.shared;
}

export { siteConfig };
